import React, { useEffect, useRef } from "react";
import { Box, Card, Typography, Stack, Button, Paper, CardContent, Grid, 
  // Tooltip, IconButton 
} from "@mui/material";
import Select from "react-select";
import FilterListIcon from "@mui/icons-material/FilterList";
import UserReportsController from "./UserReportController";
import Loader from "components/Loader";
// import OpenWith from "@mui/icons-material/OpenWith";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import {
  salesByCategory,
  salesByDivision
} from "./Charts/salesChart";

const UserReports2 = () => {

  const {
    loading,
    // selectedDate, setSelectedDate, reportData, goTo, reload,

    // // Filters
    // reportTypes,
    // categories,
    parties,

    // selectedReportType,
    // selectedCategorie,
    selectedParty,

    // setSelectedReportType,
    // setSelectedCategorie,
    setSelectedParty,


    // Reports Data
    // targetAchievementReportData,
    // collectionsReportData,
    // pendingDispatchReportData,
    // outstandingReportData,
    // salesReportData,
    // stockLevelReportData,
    salesView,
    setSalesView,
    salesReportData,   // ✅ ADD
    reportData,
  } = UserReportsController();

  const palette = [
    "#1e88e5",
    "#00bfa5",
    "#00bcd4",
    "#8e9aa8",
    "#6b7280",
    "#3b82f6",
    "#fb923c",
  ];

  const salesRef = useRef(null);
  const charts = useRef({});

  const destroyCharts = (keys = []) => {
    keys.forEach((k) => {
      if (charts.current[k]) {
        try {
          charts.current[k].destroy();
        } catch (err) {
          console.warn("Chart destroy failed:", k, err);
        }
        delete charts.current[k];
      }
    });
  };



  useEffect(() => {
    if (!salesRef.current || !salesReportData) return;

    destroyCharts(["sales"]);

    try {
      const ctx = salesRef.current.getContext("2d");

      if (salesView === "category") {
        charts.current.sales = salesByCategory(
          ctx,
          salesReportData,
          palette
        );
      }

      if (salesView === "division") {
        charts.current.sales = salesByDivision(
          ctx,
          reportData?.salesDivision,
          palette
        );
      }
    } catch (err) {
      console.error("Sales chart error:", err);
    }
  }, [salesView, salesReportData, reportData]);





  return (
    <Box mt={8}>
      {loading && (
        <Box sx={{ position: "absolute", inset: 0, display: "grid", placeItems: "center", zIndex: 2000 }}>
          <Paper sx={{ p: 3, display: "flex", alignItems: "center", gap: 2 }}>
            <Loader />
            <Typography>Please wait, fetching data...</Typography>
          </Paper>
        </Box>
      )}

      <Card sx={{ p: 2 }}>
        <Typography variant="h4" align="center">User Reports 2</Typography>

        <Box>
          <Stack direction="row" alignItems="center" spacing={2} sx={{ flexWrap: "wrap" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mr: 1 }}>
              <FilterListIcon color="primary" />
              <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>Filters</Typography>
            </Box>

            <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", flex: 1 }}>
              <Box sx={{ minWidth: 200 }}>
                <Typography variant="caption" sx={{ color: "#4b5563", }} >
                  Sales Officer
                </Typography>

                <Select
                  options={parties}
                  value={selectedParty}
                  onChange={(value) => setSelectedParty(value)}
                  placeholder="Select Sales Officer"
                  isSearchable
                  isClearable
                  // windowThreshold={50}
                  // maxHeight={300}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 })
                  }}
                />
              </Box>

            </Box>

            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 2 }}>
              <Button variant="outlined" startIcon={<FilterListIcon />} sx={{ borderRadius: "10px", px: 3, py: 1, textTransform: "none", fontWeight: 500 }}
              // onClick={handleReset}
              >Reset</Button>
            </Box>
          </Stack>
        </Box>
      </Card>

      <Grid container spacing={2} sx={{ mt: 1 }}>
        {/* Sales */}
        <Grid item xs={12} sm={6} md={8}>
          <Card sx={{ height: "100%", display: "flex", flexDirection: "column", p: 1.2, borderRadius: 2, backgroundColor: "#ffffff" }}>
            <CardContent sx={{ pb: 0.2 }}>
              <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                <Box display="flex" alignItems="center" gap={1}>
                  <TrendingUpIcon fontSize="small" color="primary" />
                  <Box>
                    <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                      Sales
                    </Typography>
                    <Typography variant="caption" color="text.secondary">Last 12 months</Typography>
                  </Box>
                </Box>

                <Box display="flex" alignItems="center" gap={1}>
                  {/* Filter Type */}
                  <Box display="flex" alignItems="center" gap={1} width={200}>
                    {/* <Select
                      sx={{ width: "100%" }}
                      options={[{ value: "division", label: "By Division" }, { value: "category", label: "By Category" }]}
                      // value={filters.stockType}
                      // onChange={handleStockTypeChange}
                      placeholder="Filter Type"
                      isClearable

                    /> */}
                    <Select
                      options={[
                        { value: "category", label: "By Category" },
                        { value: "division", label: "By Division" }
                      ]}
                      value={{ value: salesView, label: `By ${salesView}` }}
                      onChange={(opt) => setSalesView(opt.value)}
                      placeholder="Filter Type"
                      isClearable={false}
                      menuPortalTarget={document.body}
                      styles={{
                        container: (base) => ({
                          ...base,
                          width: "100%",
                        }),
                        menuPortal: (base) => ({ ...base, zIndex: 9999 })
                      }}
                    />
                  </Box>

                  {/* Maximize button opens modal for this chart */}
                  {/* <Tooltip title="Maximize" placement="top">
                    <IconButton size="small" onClick={() => openFullChart("sales")} sx={{ backgroundColor: "rgba(0,91,209,0.08)", borderRadius: "10px" }}>
                      <OpenWith sx={{ color: "#1890ff", fontSize: 20 }} />
                    </IconButton>
                  </Tooltip> */}
                </Box>
              </Box>
            </CardContent>
            <CardContent sx={{ flex: 1, py: 0.5 }}>
              <div style={{ height: 280 }}><canvas ref={salesRef} /></div>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  )
}

export default UserReports2;